(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('EtablissementSearch', EtablissementSearch);

    EtablissementSearch.$inject = ['$resource'];

    function EtablissementSearch($resource) {
        var resourceUrl = 'api/_search/etablissements/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
